import { ChevronRight } from "lucide-react";
import { Link } from "wouter";
import { resolveSsrRouteSeo } from "@/ssr/routeSeo";

type BreadcrumbListItem = {
  "@type"?: string;
  position?: number;
  name?: string;
  item?: string;
};

function breadcrumbItemsFor(pathname: string): BreadcrumbListItem[] {
  const schema = resolveSsrRouteSeo(pathname).jsonLd.find((entry) => entry["@type"] === "BreadcrumbList");
  const items = schema?.itemListElement;
  return Array.isArray(items) ? items.filter((item): item is BreadcrumbListItem => typeof item === "object" && item !== null) : [];
}

export default function VisibleBreadcrumbs({ pathname }: { pathname: string }) {
  const items = breadcrumbItemsFor(pathname);

  if (items.length < 3) return null;

  return (
    <nav aria-label="Breadcrumb" className="border-b border-[#17191c]/10 bg-[#fdfcf9] text-[#4e565f]">
      <ol className="mx-auto flex max-w-[1500px] flex-wrap items-center gap-x-1.5 gap-y-1 px-5 py-2 text-[0.58rem] font-extrabold uppercase tracking-[0.1em] sm:px-8 lg:px-10">
        {items.map((item, index) => {
          const isCurrent = index === items.length - 1;
          const label = item.name ?? "Current page";
          const href = item.item?.replace("https://duratarp.cn", "") || "/";

          return (
            <li key={`${item.position ?? index}-${label}`} className="flex min-w-0 items-center gap-1.5">
              {index > 0 ? <ChevronRight aria-hidden="true" className="h-3 w-3 shrink-0 text-[#a92732]" /> : null}
              {isCurrent ? (
                <span aria-current="page" title={label} className="max-w-[28ch] break-words text-[#17191c] [overflow-wrap:anywhere]">
                  {label}
                </span>
              ) : (
                <Link href={href} className="rounded-sm py-1 text-[#4e565f] underline-offset-4 transition hover:text-[#7a1720] hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#a92732]">
                  {label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
